import { QueryClient } from "@tanstack/react-query";

const queryConfig = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // Retry failed requests once
      refetchOnWindowFocus: false, // Optional: Disable refetch on window focus
      staleTime: 1000 * 60 * 1, // Keep data fresh for 5 minutes
      // cacheTime: 1000 * 60 * 10, // Cache for 10 minutes
    },
  },
});

export default queryConfig;
